import React, { useState, useEffect } from 'react'
import EcxSidebar from './components/EcxSidebar'
import EcxHeader from './components/EcxHeader'
import { Outlet } from 'react-router-dom'
import { useEyeconxStore } from '../../store/eyeconxStore'
import clinicService from '../../services/clinic.service'
import Loading from '../common/Loading'

function MainLayout() {
  const user = useEyeconxStore(state => state.user)
  const userInfo = useEyeconxStore(state => state.userInfo)
  const setUserInfo = useEyeconxStore(state => state.setUserInfo)
  const sidebarCollapsed = useEyeconxStore((state) => state.sidebarCollapsed);
  useEffect(() => {
    if (userInfo === null) {
      getUserInfo()
    }
  }, [])

  const getUserInfo = () => {
    clinicService.getUserInfo(user.clinicId, user.ID)
      .then(res => {
        setUserInfo(res.data)
        //console.log(res.data)
      })
      .catch(err => {
        //console.log(err)
      })
  }

  return (
    <>
      {/* Bootstrap 5.3 Layout using flexbox */}
      <div className="d-flex min-vh-100" style={{ backgroundColor: "#fcfcfc" }}>
        {/* Sidebar - auto width */}
        <div className="flex-shrink-0">
          <EcxSidebar />
        </div>

        {/* Main content area - takes remaining space */}
        <div className="d-flex flex-column flex-grow-1 transition-all"
           style={{ marginLeft: sidebarCollapsed ? "80px" : "280px" }}
        >
          {/* Header - fixed height */}
          <div className="d-flex align-items-center justify-content-center" style={{ height: "70px" }}>
            <EcxHeader />
          </div>

          {/* Content area - grows to fill remaining space */}
          <div
              className="flex-grow-1 overflow-auto"
              style={{ maxHeight: "calc(100vh - 70px)" }}
          >
            <div className="container-xxl h-100">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
       
    </>
  )
}

export default MainLayout